import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm, reset } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { handleErrors, checkPrivilege } from "common.js";
import { CircularProgress, Backdrop } from "@mui/material";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { PRIVILEGE } from "constants.js";

function Role() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const [isLoading, setIsLoading] = useState(false);
    const roleId = useParams().roleId;
    const [privilegesList, setPrivilegesList] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    const [status, setStatus] = useState(1);
    const adminType = localStorage.getItem("type");

    const { register, handleSubmit, setValue, setError, formState: { errors }, reset: resetForm } = useForm();

    const fetchData = async () => {
        setIsLoading(true)
        await axios.get(BASE + "api/role/view/" + roleId, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            },
        })
            .then((response) => {
                setIsLoading(false);
                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        const responseData = response.data.data;
                        if (responseData) {
                            setPrivilegesList(responseData.privileges);
                            Object.entries(responseData.roleInfo).forEach(([key, value]) => {
                                if (key == "name" || key == "id")
                                    setValue(key, value);
                                else if (key == 'status')
                                    setStatus(value);
                                else if (key == 'privileges') {
                                    setCheckedValues(JSON.parse(value))
                                    JSON.parse(value).forEach((checkeditem, checkedindex) => {
                                        const checkedkey = Object.keys(checkeditem)[0];
                                        const checkedvalue = checkeditem[checkedkey];
                                        checkedvalue.map((permission, index) => {
                                            setValue(checkedkey + permission, true)
                                        })
                                    });
                                }
                            });
                        }
                    }
                    else {
                        toast.error(t(message));
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    const getPrivileges = async () => {
        setIsLoading(true)
        await axios.get(BASE + 'api/role/listPrivileges', {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        })
            .then((response) => {
                setIsLoading(false);
                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        const responseData = response.data.data;
                        setPrivilegesList(responseData)
                    }
                    else {
                        toast.error(t(message));
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    useEffect(() => {
        if (roleId)
            fetchData();
        else
            getPrivileges();
        resetForm();
    }, [roleId, resetForm]);

    const handleCheckboxChange = (key, permission) => {
        setCheckedValues(prevValues => {
            const existingEntry = prevValues.find(entry => entry[key]);
            if (existingEntry) {
                const updatedEntry = {
                    ...existingEntry,
                    [key]: (() => {
                        const currentPermissions = existingEntry[key];
                        if (permission === 'read') {
                            if (currentPermissions.includes('write') || currentPermissions.includes('delete')) {
                                {
                                    setValue(key + 'read', true)
                                    toast.error(t('writeOrDeleteExist'))
                                    return currentPermissions;
                                }
                            } else {
                                return currentPermissions.filter(p => p !== permission);
                            }
                        } else {
                            return currentPermissions.includes(permission)
                                ? currentPermissions.filter(p => p !== permission)
                                : [...currentPermissions, permission];
                        }
                    })(),
                };
                if (permission === 'write' || permission === 'delete') {
                    if (!updatedEntry[key].includes('read')) {
                        updatedEntry[key].push('read');
                        setValue(key + 'read', true)
                    }
                }
                return prevValues.map(entry => (entry[key] ? updatedEntry : entry));
            } else {
                const permissions = [permission];
                if (permission === 'write' || permission === 'delete') {
                    permissions.push('read');
                    setValue(key + 'read', true)
                }
                return [
                    ...prevValues,
                    { [key]: permissions }
                ];
            }
        });
    };

    const onSubmit = async (data) => {
        let inputData = {};
        inputData.name = data['name'];
        if (roleId) {
            inputData.id = roleId;
            inputData.status = status;
        }
        inputData.privileges = checkedValues.filter(obj => Object.values(obj)[0].length > 0);

        setIsLoading(true);
        axios.post(BASE + 'api/role/save', inputData, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        })
            .then((response) => {
                setIsLoading(false)
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        toast.success(t(message))
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate(`/role/manage/`);
                        }, 2000);
                    }
                    else {
                        if (message != '')
                            toast.error(t(message))
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };
    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={roleId ? t('editRole') : t('addARoles')} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <MDBox pt={6} pb={3} >
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                                <MDBox px={3}>
                                    <Grid container spacing={2} mt={5}>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('name')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <MDInput
                                                type="text"
                                                name="name"
                                                placeholder={t('enterRoleNameHere')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("name", {
                                                    required: {
                                                        value: true,
                                                        message: t('roleNameRequired')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.name && (<span className="errorMsg FloatRight">{errors.name.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <MDTypography variant="body1" className="labelStyle">{t('privileges')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            {privilegesList.map((item, index) => {
                                                const key = Object.keys(item)[0];
                                                return (
                                                    <Grid key={index} className="roleContent">
                                                        <MDTypography variant="body1" className="labelStyle roleNameStyle" >{t(key)}</MDTypography>
                                                        {
                                                            item[key].map((permission, permissionIndex) => {
                                                                return (
                                                                    <Grid key={permissionIndex}>
                                                                        <MDInput
                                                                            type="checkbox"
                                                                            name={key + permission}
                                                                            variant="standard"
                                                                            {...register(key + permission, {
                                                                            })}
                                                                            InputProps={{
                                                                                classes: { root: "inputBoxStyle" },
                                                                            }}
                                                                            onChange={e => {
                                                                                e.stopPropagation();
                                                                                handleCheckboxChange(key, permission)
                                                                            }}
                                                                            className="checkboxStyle"
                                                                        />
                                                                        <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel rolePermissionStyle">{t(permission)}</MDTypography>
                                                                    </Grid>
                                                                )
                                                            })
                                                        }
                                                    </Grid>
                                                )
                                            }
                                            )}
                                            <MDInput
                                                type="hidden"
                                                name="privileges"
                                                className="displayHidden"
                                                value={checkedValues}
                                                {...register("privileges", {
                                                    validate: (value) => {
                                                        const hasPrivilegeWithPermissions = checkedValues.some(privilege => {
                                                            const key = Object.keys(privilege)[0];
                                                            return privilege[key].length > 0;
                                                        });
                                                        if (!hasPrivilegeWithPermissions) {
                                                            return t('privilegesRequired');
                                                        }
                                                        return true;
                                                    },
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.privileges && (<span className="errorMsg FloatRight">{errors.privileges.message}</span>)}
                                        </Grid>

                                        <Grid item xs={12} sm={3} md={3}>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            <MDTypography component="span" variant="body2" className="NoteText" color="info" >{t('privilegeNote')}</MDTypography>
                                        </Grid>

                                        {roleId ?
                                            <>
                                                <Grid item xs={12} sm={3} md={3}>
                                                    <MDTypography variant="body1" className="labelStyle">{t('status')}
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={7} md={7}>
                                                    <RadioGroup
                                                        aria-labelledby="selectStatus"
                                                        value={status}
                                                        name="status"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setStatus(value);
                                                        }}
                                                        row
                                                    >
                                                        <FormControlLabel className="radioButtonIcon" value="1" control={<Radio />} label={t("active")} />
                                                        <FormControlLabel className="radioButtonIcon" value="0" control={<Radio />} label={t("inactive")} />
                                                    </RadioGroup>
                                                </Grid>
                                            </>
                                            :
                                            null}

                                        <Grid item xs={12} sm={3} md={3}>
                                        </Grid>
                                        <Grid item xs={12} sm={7} md={7}>
                                            {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("role", "write"))) ?
                                                <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>
                                                    {roleId ? t('submit') : t('Add')}
                                                </MDButton>
                                                : null
                                            }
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Role;
